function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { DAILY_SAMPLE_RATE_ABBREVIATION } from 'js/constants/plotSampleRates';
import { TIME_GRAPH_ID } from 'js/constants/graphSections';

var STATE_DEFAULT = _defineProperty({}, TIME_GRAPH_ID, DAILY_SAMPLE_RATE_ABBREVIATION);

export var PLOT_SAMPLE_RATE_RESET = 'PLOT_SAMPLE_RATE_RESET';
export var PLOT_SAMPLE_RATE_UPDATE = 'PLOT_SAMPLE_RATE_UPDATE';
export default function plotSampleRates() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : STATE_DEFAULT;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case PLOT_SAMPLE_RATE_UPDATE:
      return Object.assign({}, state, _defineProperty({}, action.plotId, action.sampleRate));

    case PLOT_SAMPLE_RATE_RESET:
      return Object.assign({}, STATE_DEFAULT);

    default:
      return state;
  }
}